import React from 'react';
import { format, parseISO } from 'date-fns';
import { Calendar as CalendarIcon } from 'lucide-react';
import { Button } from '../ui/button';
import { Calendar } from '../ui/calendar';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover';
import { cn } from '../../lib/utils';

// Reusable date field (shadcn Calendar + Popover). Stores/emits a plain 'yyyy-MM-dd' string
// so it drops into existing forms that previously used <Input type="date" />.
export const DatePicker = ({ value, onChange, placeholder = 'Pick a date', testId, disabled = false, allowClear = true }) => {
  const [open, setOpen] = React.useState(false);
  let selected;
  try {
    selected = value ? parseISO(value) : undefined;
    if (selected && isNaN(selected.getTime())) selected = undefined;
  } catch {
    selected = undefined;
  }
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
          disabled={disabled}
          data-testid={testId}
          className={cn('w-full justify-start text-left font-normal', !selected && 'text-muted-foreground')}
        >
          <CalendarIcon className="mr-2 h-4 w-4" />
          {selected ? format(selected, 'MMM d, yyyy') : <span>{placeholder}</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          selected={selected}
          onSelect={(d) => {
            onChange(d ? format(d, 'yyyy-MM-dd') : '');
            setOpen(false);
          }}
          initialFocus
        />
        {allowClear && selected && (
          <div className="border-t p-2 flex justify-end">
            <Button
              type="button"
              variant="ghost"
              size="sm"
              onClick={() => { onChange(''); setOpen(false); }}
              data-testid={testId ? `${testId}-clear` : undefined}
            >
              Clear
            </Button>
          </div>
        )}
      </PopoverContent>
    </Popover>
  );
};

export default DatePicker;
